var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b508bf50-e5f9-4e36-be88-0e653f91d3ff",
    "data-name": "C-wires layered OFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 261.2 268.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".C-wire-channel,.a90f77c9-8024-4918-b739-1825d8eaf417{fill:none;}.C-wire-channel{stroke:#d2e4f9;stroke-linecap:round;stroke-linejoin:round;stroke-width:9px;}.a90f77c9-8024-4918-b739-1825d8eaf417{stroke:#b290d1;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "efc651d2-c641-4008-add9-c7ed8474d367",
    "data-name": "Channel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M37.84,256.69V161.33a4,4,0,0,1,2-3.47l13.28-7.64a4,4,0,0,1,2-.54h13a4.07,4.07,0,0,0,2-.54L185.47,81.72a4,4,0,0,0,2-3.45V33.94a4,4,0,0,1,2.08-3.51l33.83-18.59"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a40c0bf5-25a7-4469-b813-b9f2b16e1846",
    "data-name": "OFF"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M37.84,256.69V161.33a4,4,0,0,1,2-3.47l13.28-7.64a4,4,0,0,1,2-.54h13a4.07,4.07,0,0,0,2-.54L185.47,81.72a4,4,0,0,0,2-3.45V33.94a4,4,0,0,1,2.08-3.51l33.83-18.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a90f77c9-8024-4918-b739-1825d8eaf417",
    d: "M37.84,256.69V161.33a4,4,0,0,1,2-3.47l13.28-7.64a4,4,0,0,1,2-.54h13a4.07,4.07,0,0,0,2-.54L185.47,81.72a4,4,0,0,0,2-3.45V33.94a4,4,0,0,1,2.08-3.51l33.83-18.59"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.f3279a0b.svg";
export { ForwardRef as ReactComponent };